<template>
    <div id="deliverable__in__project__list" style="padding-top: 1rem">
        <b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable" @hide="editDeliverableModalHidden" @shown="pushRoute" @hidden="removeRoute">
			<EditModal :allContacts="allContacts"  ref="refEditModal" :tabIndex="tabIndex"  :namespace="''" />
		</b-modal>
		<b-modal size="lg" hide-footer id="editSocialModal" title="Edit Social Deliverable"
			class="modal-edit-social-deliverable" @hide="editSocialModalHidden" @shown="pushRoute" @hidden="removeRoute">
			<EditSocialModal ref="refEditSocialModal" :namespace="namespace" :tabIndex="tabIndex" />
		</b-modal>
		<b-modal no-close-on-backdrop no-close-on-esc size="xl" hide-footer
	      id="editOrganicSocialMediaPlanModal" class="modal-edit-deliverable"
	      @hide="editOrganicSocialMediaPlanModalHidden" @shown="pushRoute" @hidden="removeRoute" >
	        <EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :namespace="namespace" />
	    </b-modal>

        <div
            class="deliverable-block project-block"
            :class="!userCanEditDeliverable(deliverable) ? 'read-only' : ''"
            v-for="(deliverable, index) in projectDeliverables"
            :key="'projectdeliverable-'+index"
            :id="'project__deliverable__' + deliverable.id"
        >
            <div class="delv-block-resp"
				:class="isParentProjectOnHold(deliverable.project_id) ? 'parent-project-on-hold' : ''">
            <DuplicateMediaCallFromProjectBtn :deliverableId='deliverable.id' :namespace="namespace" />
            <div class="d-flex flex-row dbox-wrapper">
                <div class="dbox-left-side dleft-inner-wrap">
                    <div class="top-row"
						:style="applyBackgroundColorIfOnHold(deliverable.project_id)">
	                    <DeliverableDropdown 
							:deliverable="deliverable" 
							:deliverableTypes="deliverableTypes" 
							:classNames="''" />
                        <div class="data-items hide-mobile">
                            <DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
                        </div>
                        <div class="data-items hide-mobile" v-if="hasPriorityField(deliverable)">
                            <span class="">PRIORITY: </span>
                            <span v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(deliverable)" :class="'listing-priority-del-'+deliverable.id">
                                <vue-star-rate
                                    :rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
                                    :maxIcon="5"
                                    :iconHeight="17"
                                    :iconWidth="17"
                                    :hasCounter="false"
                                    :key="'del-rating-'+Math.random()+deliverable.id"
                                    iconColor="var(--wf-primary)"
                                    iconColorHover="var(--wf-primary)"
                                    iconShape="circle"
                                ></vue-star-rate>
                            </span>
                        </div>
                        <template v-if="showAltStartEndDate(deliverable)">
							<div class="data-items hide-mobile" v-for="(field,index) in _.filter(deliverable.customFields, {field_key: 'start_date'})" :key="'prj-deliverable-'+Math.random()">
								<span class="">START DATE:</span>
								{{ field.value | moment("DD MMM, YYYY @ H:mm") }}
							</div>
                            <div class="data-items hide-mobile" v-for="(field,index) in _.filter(deliverable.customFields, {field_key: 'end_date'})" :key="'prj-deliverable-'+Math.random()">
								<span class="">END DATE:</span>
								{{ field.value | moment("DD MMM, YYYY @ H:mm") }}
							</div>
                            <div class="data-items" v-if="_.filter(deliverable.customFields, {field_key: 'start_date'}).length == 0">
								<span class="">START DATE:</span>
								No Date
							</div>
							<template v-if="calculateEndDate(deliverable)">
								<div class="data-items hide-mobile">
								<span class="">END DATE:</span>
								{{ calculateEndDate(deliverable) | moment("DD MMM, YYYY") }}
								</div>
							</template>
							<template v-else>
								<template v-if="_.filter(deliverable.customFields, {field_key: 'end_date'}).length == 0">
									<div class="data-items hide-mobile">
										<span class="">END DATE:</span>
									No Date
									</div>
								</template>
							</template>
						</template>
                        <template v-else>
                            <div class="data-items">
                                <span class="hide-mobile">STARTED:</span>
                                {{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
                            </div>
                            <div v-if="deliverable.all_completed" class="data-items">
                                <span class="hide-mobile">COMPLETED:</span>
                                {{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
                            </div>
                            <div v-else class="data-items">
                                <span class="hide-mobile">LAST MODIFIED:</span>
                                {{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
                            </div>
                        </template>
                    </div>
                    <DeliverableTypeIcon 
						:deliverableTypeId="deliverable.deliverable_template_id" 
						:deliverableProject="deliverable.project_id" />
                    <div class="row mobile-deli-info">
						<div class="data-items deliverable-priority" v-if="hasPriorityField(deliverable)">
							<span class="text-primary">PRIORITY: </span>
							<span v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(deliverable, true)" :class="'listing-priority-del-'+deliverable.id">
								<vue-star-rate
									:rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
									:maxIcon="5"
									:iconHeight="17"
									:iconWidth="17"
									:hasCounter="false"
									:key="'del-rating-'+Math.random()+deliverable.id"
									iconColor="var(--wf-primary)"
									iconColorHover="var(--wf-primary)"
									iconShape="circle"
								></vue-star-rate>
							</span>
						</div>
						<template v-if="showAltStartEndDate(deliverable)">
							<div class="data-items deliverable-start" v-for="(field,index) in _.filter(deliverable.customFields, {field_key: 'start_date'})" :key="index">
								<span class="text-primary">START DATE:</span>
								{{ field.value | moment("DD MMM, YYYY") }}
							</div>
							<div class="data-items deliverable-start" v-if="_.filter(deliverable.customFields, {field_key: 'start_datetime'}).length == 0">
								<span class="text-primary">START DATE:</span>
								No Date
							</div>
							<div class="data-items deliverable-end">
								<span class="text-primary">END DATE:</span>
								<template v-if="calculateEndDate(deliverable)">
									{{ calculateEndDate(deliverable) | moment("DD MMM, YYYY") }}
								</template>
								<template v-else>
									No Date
								</template>
							</div>
						</template>
						<template v-else>
							<div class="data-items deliverable-start">
								<span class="text-primary">STARTED:</span>
								{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
							<div v-if="deliverable.all_completed" class="data-items deliverable-completed">
								<span class="text-primary">COMPLETED:</span>
								{{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
							<div v-else class="data-items deliverable-last-mod">
								<span class="text-primary">LAST MODIFIED:</span>
								{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
							</div>
						</template>
						<div class="data-items no-padding deliverable-tags">
							<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"
							 :namespace="namespace" @tag-created="updateDeliverableTags"  />
						</div>
						<div class="data-items deliverable-project">
							<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
						</div>
					</div>
                    <div class="row listing-row">
                        <div :class="` ${deliverable.total_unread_messages_in_conversation > 0 ? 'col-md-7' : 'col-md-8 titles '} breakpoint__fix `" 
							:style="infoColStyle(deliverable)">
                            <div class="inside-list department--wrap--new" v-if="showDepartment(deliverable)">
                                <DeliverableDepartments :deliverable="deliverable" :namespace="namespace" />
                            </div>
                            <div
                                class="deliverable-title edit-d-title"
                                @click="showModalFn(deliverable, false)"
                            >
                                <div v-b-tooltip.hover title="Remove from project" v-if="userCanEditDeliverable(deliverable)" class="option-bar" @click.stop="$root.$emit('showRemoveDeliverableFromProjModal', deliverable.id)">
                                    <span><i class="fas fa-trash"></i></span>
                                </div>
                                {{ deliverable.title }}
                            </div>
                            <div class="mobile-task-expand-button-area">
								<div class="mobile-task-exp-btn">
									<CollapseTaskBtn :deliverable="deliverable" :index="index" :expandAll="expandAll" />
								</div>
							</div>
                        </div>
						<div 
							v-if="!isMobile() && 
							getSystemSetting('is_chat_enabled') &&
							deliverable.total_unread_messages_in_conversation > 0" 
							class="col-md-1 infos titles" 
							@click="showModalFn(deliverable, true)">
							<div class="d-flex flex-row">
								<ListMessageCounter :deliverable="deliverable" />
							</div>
						</div>
                        <div v-if="!isMobile()" class="col-md-4 infos">
                            <div class="d-flex flex-row">
                                <DeliverableListCoordinators 
								v-if="showInfoCol(deliverable) && getSystemSetting('media_call__show_owner')" 
								class="deliverable-list-coordinators" 
								:deliverable="deliverable" />

                                <DeliverableListContacts v-if="showInfoCol(deliverable)" class="deliverable-list-contacts" :deliverable="deliverable" />

                                <DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"
								 :namespace="namespace" @tag-created="updateDeliverableTags"  />

                                <DeliverableStatusOverview :deliverable="deliverable" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div>
                                <b-collapse :visible="expandAll" :id="'task-listing-collapse-'+index" @shown="scrollToTaskAfterExpand(deliverable.tasks)">
                                    <div v-if="isMobile()" class="col-md-6 infos responsive-infos">
                                        <div class="d-flex flex-row">
                                        </div>
                                    </div>
                                    <TaskFieldLabels :fullDeliverables="projectDeliverables" :tasks="deliverable.tasks" :deliverableId="deliverable.id" :deliverable="deliverable" :namespace="namespace"/>
                                    <TaskFields :fullDeliverables="projectDeliverables" :deliverable="deliverable" :deliverableId="deliverable.id" :myWeek="false" :tasks="deliverable.tasks" :users="deliverable.users" :namespace="namespace"/>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dbox-right-side dright-inner-wrap">
                    <CollapseTaskBtn :deliverable="deliverable" :expandAll="expandAll" :index="index" />
                </div>
            </div>

            </div>
        </div>
        <div v-if="projectDeliverables.length == 0">
            Project has no deliverables assigned to it yet.
        </div>
        <div class="pagination-wrapper">
            <pagination :data="allProjectDeliverablesPaginationData" @pagination-change-page="onChangePage" :limit="5"></pagination>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ProjectCustomFields from "../common/ProjectCustomField";
import EditProjectModal from "./EditProjectModal"
import ProjectDatesRibbon from "./ProjectDatesRibbon";
import vueStarRate from "vue-js-star-rating";
import ProjectDepartments from "./ProjectDepartments";
import EditModal from "./EditModal";
import EditSocialModal from "./EditSocialModal.vue";
import EditOrganicSocialMediaPlanModal from "./EditOrganicSocialMediaPlanModal";
import TaskFields from "./TaskFields";
import TaskFieldLabels from "./TaskFieldLabels";
import CreateContactModal from "./CreateContactModal";
import UpdateContactModal from "./EditContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import UpdateSpokespersonModal from "./EditSpokespersonModal";
import CreateSpokespersonModal from "./CreateSpokespersonModal";
import DeliverableTypeIcon from './DeliverableTypeIcon';
import DuplicateMediaCallFromProjectBtn from "../common/DuplicateMediaCallFromProjectBtn";

import AddProjectDeliverable from '@/csmworkflow/js/views/AddProjectDeliverable';

import UpdateWhoModal from "./EditWhoModal";
import CreateWhoModal from "./CreateWhoModal";


import DeliverableDropdown from "./DeliverableDropdown";
import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableType from "./DeliverableType";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableListContacts from "./DeliverableListContacts";
import DeliverableListCoordinators from "./DeliverableListCoordinators";
import ListMessageCounter from "./ListMessageCounter";
import TaskCompletionGraph from "./TaskCompletionGraph";
import CollapseTaskBtn from "./CollapseTaskBtn";
import DeliverableDatesRibbon from "./DeliverableDatesRibbon";
import DeliverableStatusOverview from './DeliverableStatusOverview';

export default {
	props: {
        myWeek: false,
        filterQuery: '',
        expandAll: false,
        inProject:false,
        namespace:"",
    },
	data() {
		return {
			tabIndex: 0,
		}
	},
    components: {
        ProjectCustomFields,
		AddProjectDeliverable,
		EditProjectModal,
		ProjectDatesRibbon,
		vueStarRate,
		ProjectDepartments,
		EditModal,
		EditSocialModal,
		EditOrganicSocialMediaPlanModal,
		TaskFields,
		TaskFieldLabels,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		DeliverableDropdown,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		ListMessageCounter,
		DuplicateMediaCallFromProjectBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		ViewTitleModal,
		DeliverableTypeIcon,
		DeliverableProjects,
		DeliverableType,
        DeliverableStatusOverview
    },
    methods: {
    	...mapActions({
    	  fetchProjects (dispatch, payload) {
    	    return dispatch(this.namespace + 'fetchProjects', payload)
    	  },
    	  fetchUserManageProjects (dispatch, payload) {
    	    return dispatch(this.namespace + 'fetchUserManageProjects', payload)
    	  },
    	  fetchDeliverableUnreadMessageCount (dispatch, payload) {
    	    return dispatch(this.namespace + 'fetchDeliverableUnreadMessageCount', payload)
    	  },
    	}),
		...mapMutations({
			setDataLoading(commit, payload) {
				return commit(this.namespace + 'setDataLoading', payload)
			},
		}),
    	calculateEndDate(deliverable) {
    		let latestDueDate = null;

    		let end_date = _.filter(deliverable.customFields, { field_key: 'end_date' });
    		if (end_date.length > 0) {
    			return end_date[0].value;
    		}
    		let end_datetime = _.filter(deliverable.customFields, { field_key: 'end_datetime' });
    		if (end_datetime.length > 0) {
    			return end_datetime[0].value;
    		}
    		let publish_datetime = _.filter(deliverable.customFields, { field_key: 'publish_datetime' });
    		if (publish_datetime.length > 0) {
    			return publish_datetime[0].value;
    		}

    		if (_.filter(deliverable.customFields, {field_key: 'end_date'}).length == 0) {
	    		if (deliverable.tasks && deliverable.tasks.length > 0) {
	    			deliverable.tasks.forEach(x => {
	    				const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
	    				if (dueDateField && dueDateField.value && (!latestDueDate || latestDueDate < dueDateField.value)) latestDueDate = dueDateField.value;
	    			});
	    		}
	    	}
    		return latestDueDate;
    	},
        userCanEditDeliverable(deliverable) {
            const userId = localStorage.getItem("userId");
            const project = this.projectDetail;

            if (this.userAbilities.accessAllProjects) {
                return true;
            }

            let isManager = false;
            if (project.engagement_manager instanceof Object && project.project_lead instanceof Object) {
                isManager = userId == project.engagement_manager.id || userId == project.project_lead.id;
            } else {
                isManager = userId == project.engagement_manager || userId == project.project_lead;
            }

            return (this.userAbilities.editMediaCall && isManager);
        },
		onChangePage(data) {
			this.fetchProjects(data);
		},
		showModalFn(deliverable, openToChatTab) {
			let that = this;
			that.setDataLoading(true);
			// shows edit deliverable modal
			const deliverableId = deliverable.id;
			const deliverableTemplateSlug = that.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			if (
				openToChatTab == true &&
				(
					deliverableTemplateSlug == "marketing-project" ||
					deliverableTemplateSlug == "media-call" ||
					deliverableTemplateSlug == "media-event" ||
					deliverableTemplateSlug == "news-release" ||
					deliverableTemplateSlug == "writing-assignment"
				)
			) {
				// openToChatTab == true, clicked on unread message count chat bubble icon
				// Contact is tab1, Chat is tab2
				that.tabIndex = 1;
			} else {
				that.tabIndex = 0;
			}
			this.$store
				.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {

					const currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = that.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + that.deliverableDetail.title;
					}
					if (deliverableTemplateSlug === "organic-social-media-plan") {
						that.$bvModal.show("editOrganicSocialMediaPlanModal");
					} else if (deliverableTemplateSlug === "social-media") {
						that.$bvModal.show("editSocialModal");
					} else {
						that.$bvModal.show("editDeliverableModal");
					}
					that.setDataLoading(false);
				});
		},

		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
				history.pushState(
					{},
					null,
					'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
				this.$router.push({name: 'dashboard'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
			}
		},
        editDeliverableModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		editSocialModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		editOrganicSocialMediaPlanModalHidden(){
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},

        hasPriorityField(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
        showInfoCol(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		infoColStyle(deliverable) {
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			if (deliverableTemplateSlug == "project-deliverable") {
				// return 'height:96px';
				return '';
			} else {
				return null;
			}
		},
		showDepartment(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
        showAltStartEndDate(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug != "media-call";
		},

        scrollToTaskAfterExpand(tasks) {
            if (this.taskHighlighted) {
                let hasThisTask = false;
                tasks.forEach(x => {
                    if (x.id == this.taskHighlighted) {
                        hasThisTask = true;
                    }
                });

                if (hasThisTask) {
                    const taskElOffset2 = $(".task-fields .field-block .task__title__" + this.taskHighlighted).offset();
                    window.scrollTo({top: taskElOffset2.top - 195, behavior: 'smooth'});
                }
            }
        },
		updateDeliverableTags(updatedDeliverableId) {
			let deliverableToUpdate;
			if (this.projectDeliverables instanceof Array) {
				deliverableToUpdate = this.projectDeliverables.find(x => x.id == updatedDeliverableId);
			} else {
				for (let i of Object.keys(this.projectDeliverables)) {
					deliverableToUpdate = this.projectDeliverables[i].find(x => x.id == updatedDeliverableId);
					if (deliverableToUpdate != null) break;
				}
			}
			if (deliverableToUpdate != null) {
				deliverableToUpdate.tags = this.deliverableDetail.tags;
			} else {
				console.error(`DeliverablesInProjectList Deliverable with ID ${updatedDeliverableId} not found.`);
			}
		},
		isParentProjectOnHold(project_id) {
			if (
				project_id &&
				project_id.project_status &&
				project_id.project_status.slug &&
				project_id.project_status.slug == 'on-hold'
			) {
				return true;
			}
			return false;
		},
		applyBackgroundColorIfOnHold(project_id) {
            if (
                project_id &&
                project_id.project_status &&
                project_id.project_status.color &&
                project_id.project_status.slug &&
                project_id.project_status.slug == 'on-hold'
            ) {
                return { backgroundColor: project_id.project_status.color };
            }
            return {};
        },
    },
    computed: {
    	...mapGetters([
		"dataLoading",
		"systemSettings",
		"getSystemSetting",
		"getDeliverableTemplateSlug",
	]),
		...mapState({
    		state (state) {
    		return state[this.namespace]
    		},
    		projects (state, getters) {
    		return getters[this.namespace + 'projects']
    		},
    		projectDeliverables (state, getters) {
    		return getters[this.namespace + 'projectDeliverables']
    		},
    		allProjectDeliverablesPaginationData (state, getters) {
    		return getters[this.namespace + 'allProjectDeliverablesPaginationData']
    		},
    		projectDetail (state, getters) {
    		return getters[this.namespace + 'projectDetail']
    		},
    		deliverableDetail (state, getters) {
    		return getters[this.namespace + 'deliverableDetail']
    		},
    		allContacts (state, getters) {
    		return getters[this.namespace + 'allContacts']
    		},
    		userAbilities (state, getters) {
    		return getters['userAbilities']
    		},
    		deliverableTypes (state, getters) {
    		return getters[this.namespace + 'deliverableTypes']
    		},
    		userHasProjects (state, getters) {
    		return getters[this.namespace + 'userHasProjects']
    		},
    		taskHighlighted (state, getters) {
    		return getters[this.namespace + 'taskHighlighted']
    		},
    	}),

        _() {
			return _;
		},
    },
    destroyed() {
        this.$root.$off('bv::modal::hide')
    },
    mounted() {
        self = this
        this.$root.$on('bv::modal::hide', function(bvEvent, modalId) {
			if(modalId == 'editDeliverableModal' ||
			   modalId == 'editOrganicSocialMediaPlanModal') {
				self.sortTasks({sortKey: false, deliverables: self.projectDeliverables, sortFields: true, namespace:self.namespace})
			}
		});
        if (!this.projects && !this.projects.length) {
            this.fetchProjects();
        }
        this.fetchUserManageProjects();
    },
	watch: {
		projectDeliverables: {
			handler(newItems, oldItems) {
				if (this.dataLoading) {
					// fetchDeliverables has completed, dataLoading = false, 
					// call count api only once after allDeliverables array has value
					if (JSON.stringify(newItems) !== JSON.stringify(oldItems)) {
						// Call api when userDeliverables or userDeliverables properties change
						if (newItems.length > 0) {
							this.fetchDeliverableUnreadMessageCount();
						}
					}
				}
			},
			deep: true
		},
	},
}
</script>

<style>

</style>

